import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { Redirect, Route, Switch } from 'react-router-dom';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { useCommerceHub } from './hooks/useCommerceHub';
import AppLayout from './layouts/AppLayout';
import ErrorPage from './pages/ErrorPage';
import HubSpotCreditsPage from './pages/HubSpotCreditsPage';
import MobileBundlePage from './pages/MobileBundlePage';
import MobileCommerceHubPage from './pages/MobileCommerceHubPage';
import MobileFreeToolsPage from './pages/MobileFreeToolsPage';
import MobileMarketingPlusPage from './pages/MobileMarketingPlusPage';
import MobileProductPage from './pages/MobileProductPage';
import MobileSmartCrmPage from './pages/MobileSmartCrmPage';
import MobileSuitePage from './pages/MobileSuitePage';
import { useAppSelector } from './reducers';
import { isAppAuthSelector } from './selectors/AuthSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductPageRoute = ({
  path,
  Component = MobileProductPage,
  productLine
}) => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  if (isAppAuth) {
    return /*#__PURE__*/_jsx(Route, {
      path: path,
      render: () => /*#__PURE__*/_jsx(Component, {
        productLine: productLine
      })
    });
  }
  return /*#__PURE__*/_jsx(Route, {
    path: `${path}/:tab?`,
    render: ({
      match: {
        params: {
          tab
        }
      }
    }) => {
      if (tab) {
        return /*#__PURE__*/_jsx(Redirect, {
          to: createToObject(`${path}`)
        });
      }
      return /*#__PURE__*/_jsx(Component, {
        productLine: productLine
      });
    }
  });
};
export default function MobileRoutes() {
  // TODO: Wrap with Public application component HOC
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const {
    showCommerceHub
  } = useCommerceHub();
  return /*#__PURE__*/_jsx(AppLayout, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [isAppAuth && /*#__PURE__*/_jsx(Route, {
        path: "/:page/*",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => {
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              pathname: `/${page}`
            })
          });
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/bundle",
        component: MobileBundlePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/marketing-plus",
        component: MobileMarketingPlusPage
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/suite",
        Component: MobileSuitePage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/splash/:tab?",
        render: ({
          location,
          match: {
            params: {
              tab
            }
          }
        }) => {
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              pathname: tab ? `/suite/${tab}` : '/suite'
            })
          });
        }
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/sales",
        productLine: SALES
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/service",
        productLine: SERVICE
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/content",
        productLine: CMS
      }), /*#__PURE__*/_jsx(Route, {
        path: "/cms",
        render: ({
          location
        }) => {
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              pathname: '/content'
            })
          });
        }
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/marketing",
        productLine: MARKETING
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/data",
        productLine: OPERATIONS
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/operations",
        to: "/data"
      }), /*#__PURE__*/_jsx(ProductPageRoute, {
        path: "/smart-crm",
        Component: MobileSmartCrmPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/commerce",
        render: () => {
          if (!showCommerceHub) {
            return /*#__PURE__*/_jsx(Redirect, {
              to: createToObject('/suite')
            });
          }
          return /*#__PURE__*/_jsx(MobileCommerceHubPage, {});
        }
      }), /*#__PURE__*/_jsx(Route, {
        path: "/crm",
        component: MobileFreeToolsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/breeze-intelligence/*",
        render: ({
          location
        }) => {
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              pathname: '/hubspot-credits'
            })
          });
        }
      }), /*#__PURE__*/_jsx(Route, {
        exact: true,
        path: "/hubspot-credits",
        component: HubSpotCreditsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/hubspot-credits/*",
        render: ({
          location
        }) => {
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              pathname: '/hubspot-credits'
            })
          });
        }
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/",
        exact: true,
        to: createToObject('/marketing')
      }), /*#__PURE__*/_jsx(Route, {
        component: ErrorPage
      })]
    })
  });
}